module.exports = __webpack_public_path__ + "b54458d0eafd9498291631b1a5ceafd7.jpg";